module.exports = __webpack_public_path__ + "static/media/noun-refresh-4810604-142350.8691f2b1.svg";